import { MessageBox } from 'element-ui';
import Vue from 'vue'
function confirmation(message) {

  return function (target, name, descriptor) {
    let oldValue = descriptor.value;
    descriptor.value = function (...args) {
      MessageBox.confirm(message, '提示')
        .then(oldValue.bind(this, ...args))
        .catch(() => { });
    };

    return descriptor;
  }
}
confirmation.install = function (Vue, options) {
  Vue.confirmation = confirmation
  window.confirmation = confirmation
  Object.defineProperties(Vue.prototype, {
    confirmation: {
      get() {
        return confirmation
      }
    }
  })
}

Vue.use(confirmation)
export default confirmation